export const eventsSelector = state => state.events.events;

export const eventsLoadingSelector = state => state.events.isLoading;

export const eventsErrorsSelector = state => state.events.error;
